






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import debounce from 'lodash.debounce';

@Component
export default class SearchInput extends Vue {
  $refs!: { searchInput: HTMLInputElement };

  @Prop({ default: '' }) value!: string;

  @Prop() placeholder!: string;

  @Prop() expandable!: boolean;

  @Prop() autofocus!: boolean;

  @Prop() disabled!: boolean;

  @Prop({ default: 100 }) debounceTime!: number;

  isEditing = false;

  val = this.value;

  get hasValue() {
    return this.val ? true : false;
  }

  created() {
    this.onChange = debounce(this.onChange, this.debounceTime);
  }

  @Watch('autofocus')
  setAutofocus() {
    if (this.autofocus) {
      const { searchInput } = this.$refs;
      searchInput.focus();
    }
  }

  onChange(value: string) {
    this.$emit('change', value);
    this.$emit('input', value);
    this.val = value;
  }

  focus() {
    this.isEditing = true;
  }

  blur() {
    this.isEditing = false;
  }

  clear() {
    this.onChange('');
  }
}
